import { $logPost } from '../axios';
export const logUrl = params => {
  return $logPost('', { ...params });
};
